import React, {PropTypes} from 'react'
import { Flex, Box } from 'reflexbox'

const Waterfall = ({style, children, flexProps, boxProps}) => {
  const flattenedChildren = [].concat.apply([], children)

  return (
    <Flex wrap={true} style={style} {...flexProps}>
      {flattenedChildren.map((children, i) => <Box key={i} {...boxProps}>{children}</Box>)}
    </Flex>
  )
}

Waterfall.propTypes = {
  children: PropTypes.array.isRequired,
  flexProps: PropTypes.object,
  boxProps: PropTypes.object
}

export default Waterfall



/** WEBPACK FOOTER **
 ** ./src/components/common/Waterfall.js
 **/